import React, { Component } from 'react'

export default class QuoteButton extends Component {
  render() {
    return (
      <div className="jumbotron">
        <a className="btn btn-primary" href={process.env.REACT_APP_QUOTE_PATH}>Quote Form</a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/QuoteButton/index.js